import { css, keyframes } from "@emotion/react";

// Animations
const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(119, 0, 255, 0.3); }
  70% { box-shadow: 0 0 0 12px rgba(119, 0, 255, 0); }
  100% { box-shadow: 0 0 0 0 rgba(119, 0, 255, 0); }
`;

const gradientShift = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;


// Shared styles for post-checkout pages
export const page = css`
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

export const card = css`
  width: 100%;
  max-width: 720px;
  background: rgba(20, 22, 26, 0.7);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 2rem;
  color: #e6e6e6;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
`;

export const title = css`
  font-size: 1.75rem;
  line-height: 1.2;
  margin: 0 0 0.75rem 0;
  background: linear-gradient(90deg, #a78bfa, #6366f1, #06b6d4);
  background-size: 200% 200%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: ${gradientShift} 6s ease infinite;

  span {
    display: inline-block;
    margin-top: 0.75rem;
    padding: 0.25rem 0.6rem;
    border-radius: 12px;
    color: #e8eaf6;
    font-size: 1.3rem;
    padding: 10px;
    letter-spacing: 0.2px;
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.18), rgba(6, 182, 212, 0.12));
    border: 1px solid rgba(255, 255, 255, 0.14);
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.06),
      0 6px 18px rgba(0, 0, 0, 0.25),
      0 2px 10px rgba(6, 182, 212, 0.12);
    position: relative;
    overflow: hidden;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      width: 40%;
      left: -40%;
      background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.12), transparent);
    }

    @media (prefers-reduced-motion: reduce) {
      &::after { display: none; }
    }
  }
`;

export const subtitle = css`
  margin: 0 auto 1.25rem auto;
  max-width: 520px;
  color: #a8b3cf;
`;

export const divider = css`
  height: 1px;
  width: 100%;
  background: linear-gradient(90deg, rgba(167, 139, 250, 0), rgba(167, 139, 250, 0.35), rgba(6, 182, 212, 0));
  margin: 1.25rem 0 1.5rem 0;
  border: 0;
`;

export const metaRow = css`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 1.25rem;
`;

export const pill = css`
  padding: 0.5rem 0.75rem;
  border-radius: 999px;
  font-size: 0.85rem;
  letter-spacing: 0.2px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.04);
`;

export const cta = css`
  appearance: none;
  border: 0;
  cursor: pointer;
  padding: 0.8rem 1.1rem;
  border-radius: 12px;
  color: white;
  font-weight: 600;
  background: linear-gradient(135deg, #8b5cf6, #6366f1, #06b6d4);
  background-size: 200% 200%;
  transition: transform 120ms ease, filter 120ms ease, background-position 300ms ease;
  animation: ${pulse} 2.2s ease-out infinite;

  &:hover {
    transform: translateY(-1px);
    filter: brightness(1.05);
    background-position: 100% 0%;
  }
  &:active { transform: translateY(0); }
`;

export const spinner = css`
  display: inline-block;
  width: 22px;
  height: 22px;
  border: 3px solid rgba(255, 255, 255, 0.18);
  border-top-color: #8b5cf6;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export const errorBox = css`
  padding: 1rem;
  border-radius: 12px;
  background: rgba(239, 68, 68, 0.08);
  border: 1px solid rgba(239, 68, 68, 0.35);
  color: #fecaca;
`;
